import { Routes } from '@angular/router';
import loadMembership from '../guards/load-membership.metadata';
import { EmemberComponent } from '../emember.component';
import setPageMembershipOffer from '../guards/set-page-membership-offer';
import setPageJoin from '../guards/set-page-join';
import setPageTitle from '../guards/set-page-title';
import ensurePriceLoadedGuard from '../guards/ensure-price-loaded.guard';
import defaultRouting from '../guards/default-routing.hoosier';
import { routes as accountRoutes } from '../../account/account.routes';
import { routes as quickRenewRoutes } from '../../quick-renew/quick-renew.routes';
import { routes as membershipOffersRoutes } from '../../membership-offers/membership-offers.routes';
import { routes as joinRoutes } from '../../join/join.routes';
import { routes as mobileRenewRoutes } from '../../mobile-renew/mobile-renew.routes';

export const routes: Routes = [
  {
    path: 'join',
    loadComponent: () => import('../../join/join').then((c) => c.Join),
    canActivate: [setPageTitle, ensurePriceLoadedGuard, setPageJoin('join')],
    children: joinRoutes,
  },
  {
    path: 'gift',
    loadComponent: () => import('../../join/join').then((c) => c.Join),
    canActivate: [setPageTitle, ensurePriceLoadedGuard, setPageJoin('gift')],
    children: joinRoutes,
  },
  {
    path: 'account',
    loadComponent: () => import('../../account/account').then((c) => c.Account),
    canActivate: [setPageTitle, loadMembership],
    children: accountRoutes,
  },
  {
    path: 'renew',
    loadComponent: () => import('../../quick-renew/quick-renew').then((c) => c.QuickRenew),
    canActivate: [setPageTitle],
    children: quickRenewRoutes,
  },
  {
    path: 'offers',
    loadComponent: () => import('../../membership-offers/membership-offers').then((c) => c.MembershipOffers),
    canActivate: [setPageTitle, ensurePriceLoadedGuard, setPageMembershipOffer('offers')],
    children: membershipOffersRoutes,
  },
  {
    path: 'gift-offers',
    loadComponent: () => import('../../membership-offers/membership-offers').then((c) => c.MembershipOffers),
    canActivate: [setPageTitle, ensurePriceLoadedGuard, setPageMembershipOffer('gift-offers')],
    children: membershipOffersRoutes,
  },
  {
    path: 'contact',
    loadComponent: () => import('../../contact/contact.component').then((c) => c.Contact),
    canActivate: [setPageTitle],
  },
  {
    path: 'mobile-renew',
    loadComponent: () => import('../../mobile-renew/mobile-renew').then((c) => c.MobileRenew),
    canActivate: [setPageTitle, loadMembership],
    children: mobileRenewRoutes,
  },
  {
    path: '',
    component: EmemberComponent,
    canActivate: [defaultRouting()],
  },
];
